import gql from 'graphql-tag'

export const getTicketById = gql`
  query($ticketId: Int!) {
    getTicketById(
      ticketId: $ticketId
    ) {
      id
      name
      content
      expectedTime
      createdAt
      status
      priority
      expiring
      closed
      histories {
        id
        user {
          id
          username
        }
        actionCode
        additionalInfo
        createdAt
      }
      labels {
        id
        content
        color
      }
      users {
        founder {
          id
          username
        }
        assignees {
          id
          username
        }
        supervisors {
          id
          username
        }
      }
      relatedTickets {
        id
        name
      }
    }
  }
`

export const getMyTickets = gql`
  query($paging: PagingQuery, $order: TicketsOrder, $filter: TicketsFilter) {
    getMyTickets(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      tickets {
        id
        name
        expectedTime
        createdAt
        status
        priority
        expiring
        closed
        labels {
          id
          content
          color
        }
        users {
          founder {
            username
            emails
          }
          assignees {
            username
            emails
          }
          supervisors {
            username
            emails
          }
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getAllTickets = gql`
  query($paging: PagingQuery, $order: TicketsOrder, $filter: TicketsFilter) {
    getAllTickets(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      tickets {
        id
        name
        expectedTime
        createdAt
        status
        priority
        expiring
        closed
        users {
          founder {
            username
          }
          assignees {
            username
          }
          supervisors {
            username
          }
        }
      }
    }
  }
`

export const getTicketsRelationCandidates = gql`
  query {
    getTicketsRelationCandidates {
      users {
        id
        username
      }
      labels {
        id
        content
        color
      } 
      tickets {
        id
        name
      }
    }
  }
`

export const newTicket = gql`
  mutation($files: [NewFileInput!]!, $ticketInput: TicketInput!) {
    newTicket(
      files: $files,
      ticketInput: $ticketInput
    ) {
      id
    }
  }
`

export const editTicketName = gql`
  mutation($newName: String!, $ticketId: Int!) {
    editTicketName(
      newName: $newName,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const editTicketContent = gql`
  mutation($newFiles: [NewFileInput!]!, $fileIds: [Int!]!, $content: String!, $ticketId: Int!) {
    editTicketContent(
      newFiles: $newFiles,
      fileIds: $fileIds,
      content: $content,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const editTicketExpectedTime = gql`
  mutation($expectedTime: String!, $ticketId: Int!) {
    editTicketExpectedTime(
      expectedTime: $expectedTime,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const editTicketPriority = gql`
  mutation($priority: TicketPriority!, $ticketId: Int!) {
    editTicketPriority(
      priority: $priority,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const commentToTicketById = gql`
  mutation($files: [NewFileInput!]!, $content: String!, $ticketId: Int!) {
    commentToTicketById(
      files: $files,
      content: $content,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const editComment = gql`
  mutation($newFiles: [NewFileInput!]!, $fileIds: [Int!]!, $content: String!, $historyId: Int!, $ticketId: Int!) {
    editComment(
      newFiles: $newFiles,
      fileIds: $fileIds,
      content: $content,
      historyId: $historyId,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const completeTicketById = gql`
  mutation($ticketId: Int!) {
    completeTicketById(
      ticketId: $ticketId
    )
  }
`

export const closeTicketById = gql`
  mutation($ticketId: Int!) {
    closeTicketById(
      ticketId: $ticketId
    )
  }
`

export const reopenTicketById = gql`
  mutation($ticketId: Int!) {
    reopenTicketById(
      ticketId: $ticketId
    )
  }
`

export const reprocessTicketById = gql`
  mutation($ticketId: Int!) {
    reprocessTicketById(
      ticketId: $ticketId
    )
  }
`

export const deleteTicketById = gql`
  mutation($ticketId: Int!) {
    deleteTicketById(
      ticketId: $ticketId
    )
  }
`

export const updateRelatedUsers = gql`
  mutation($type: UserTicketType!, $ticketId: Int!, $usernames: [String!]!, $userIds: [Int!]!) {
    updateRelatedUsers(
      type: $type,
      ticketId: $ticketId,
      usernames: $usernames,
      userIds: $userIds
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const updateTicketLabels = gql`
  mutation($labelIds: [Int!]!, $ticketId: Int!) {
    updateLabels(
      labelIds: $labelIds
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`

export const relateTicket = gql`
  mutation($relatedTickets: [ReducedTicketInput!]!, $ticketId: Int!) {
    relateTicket(
      relatedTickets: $relatedTickets,
      ticketId: $ticketId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`
